import React, { useEffect, useRef, useState } from "react";
import styles from "./Table.module.css";
import {
  Box,
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { FaPlus } from "react-icons/fa";
import Modal from "../../../../components/modal/Modal";
import { List } from "antd";
import { GoDotFill } from "react-icons/go";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";
const Table = () => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const SeatingArrangement = useSelector(
    (state) => state.EventPlanningReducer.Seating
  );
  const timeout = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      EventPlanningMiddleware.eventTables({ id: EventDetails?.id, name: "" })
    ).then((data) => {});
  }, []);

  const onSearch = (val) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      // setloading(true);
      dispatch(
        EventPlanningMiddleware.eventTables({ id: EventDetails?.id, name: val })
      ).then((data) => {
        // setguests({
        //   guests: data?.tables?.tables?.[0]?.guests,
        //   index: 0,
        //   tableName: data?.tables?.tables?.[0]?.name,
        // });
        // setloading(false);
      });
      // .catch(() => setloading(false));
    }, 1500);
  };

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem}>
        <div className={styles.listLeft}>
          <TextComponent text={item?.name} textClass={styles.listName} />
          <TextComponent
            text={`${item?.seats} Seats`}
            textClass={styles.listSeats}
          />
        </div>
        <div className={styles.listRight}>
          <div className={styles.subleft_left}>
            <GoDotFill className={styles.ass_dot} />
            <TextComponent
              text={`${item?.assigned} Assigned`}
              textClass={styles.listSeats}
            />
          </div>
          <div className={styles.subleft_right}>
            {item?.vacant == "0" ? null : (
              <GoDotFill className={styles.vac_dot} />
            )}
            <TextComponent
              text={
                item?.vacant == "0" ? "No Vacancy" : `${item?.vacant} Vacant`
              }
              textClass={
                item?.vacant == "0" ? styles.listNoVacancy : styles.listVacancy
              }
            />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainCont}>
      <div className={styles.header}>
        <div className={styles.searchDiv}>
          <SearchInput
            placeholder={"Search"}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
        <div
          className={styles.addTableBtn}
          onClick={() => setIsModalOpen(true)}
        >
          <FaPlus className={styles.addIcon} />
          <TextComponent text={"Add Table"} textClass={styles.addText} />
        </div>
      </div>
      <Box boxClass={styles.box}>
        <TextComponent
          text={SeatingArrangement?.tables?.event_name}
          textClass={styles.boxHeading}
        />
        <div className={styles.underBoxDiv}>
          <div className={styles.subUBD}>
            <TextComponent
              text={SeatingArrangement?.tables?.table_count}
              textClass={styles.UBD_Num}
            />
            <TextComponent text={"Tables"} textClass={styles.UBD_text} />
          </div>
          <div className={styles.subUBD}>
            <TextComponent
              text={SeatingArrangement?.tables?.seat_count}
              textClass={styles.UBD_Num}
            />
            <TextComponent text={"Seats"} textClass={styles.UBD_text} />
          </div>
          <div className={styles.subUBD}>
            <TextComponent
              text={SeatingArrangement?.tables?.vacant_count}
              textClass={styles.UBD_Num}
            />
            <TextComponent text={"Vacant"} textClass={styles.UBD_text} />
          </div>
        </div>
      </Box>
      <Box boxClass={styles.box}>
        <List
          className={styles.list}
          dataSource={
            SeatingArrangement?.tables?.tables?.length > 0
              ? SeatingArrangement?.tables?.tables
              : []
          }
          renderItem={renderItem}
        />
      </Box>
      {isModalOpen && (
        <AddTableModal
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
        />
      )}
    </div>
  );
};

const AddTableModal = ({ isModalOpen, setIsModalOpen }) => {
  const eventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const [tableName, setTableName] = useState("");
  const [seats, setSeats] = useState("");
  const dispatch = useDispatch();
  const createTable = () => {
    if (!tableName || !seats) {
      dispatch(
        showAlert({
          type: "error",
          message: "Please add all required information!",
        })
      );
      // seterror("Please add all required information!");
    } else if (Math.sign(seats) != 1 || seats <= 0) {
      dispatch(
        showAlert({ type: "error", message: "Please enter valid no. of seats" })
      );
    }
    // else if (seats < newTable?.group?.total_members) {
    //   dispatch(
    //     showAlert({
    //       type: "error",
    //       message: "No. of seats are less than selected group members!",
    //     })
    //   );
    // }
    else {
      // setsubmit(true);
      dispatch(
        EventPlanningMiddleware.createEventTable({
          event_id: eventDetails?.id,
          name: tableName,
          seats: seats,
        })
      )
        .then(() => {
          setIsModalOpen(false);
        })
        .catch((data) => {
          setIsModalOpen(false);
        });
    }
  };

  return (
    <Modal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      closable={true}
      // pinkBg={true}
      className={styles.modal}
    >
      <div className={styles.modalDiv}>
        <TextComponent text={"Add Table"} textClass={styles.modalHeader} />
        <InputField
          label={"Table Name"}
          styles={styles.input}
          placeholder={"Head Table"}
          value={tableName}
          onChange={(e) => setTableName(e.target.value)}
        />
        <InputField
          label={"Seats"}
          styles={styles.input}
          placeholder={"5"}
          value={seats}
          onChange={(e) => setSeats(e.target.value)}
        />
        <SubmitButton
          title="Save Table"
          btnClass={styles.modalBtn}
          onClick={createTable}
        />
      </div>
    </Modal>
  );
};

export default Table;
